export default {
  // Page title
  'adsAgent.title': 'Vinculación de atribución de agente',

  // Search fields
  'adsAgent.dateRange': 'Tiempo de operación',

  // Buttons
  'adsAgent.search': 'Buscar',
  'adsAgent.reset': 'Restablecer',
  'adsAgent.add': 'Añadir',
  'adsAgent.addAdsAgent': 'Añadir vinculación de atribución de agente',
  'adsAgent.delete': 'Eliminar',
  'adsAgent.save': 'Guardar',
  'adsAgent.cancel': 'Cancelar',

  // Table columns
  'adsAgent.serial': 'Serie',
  'adsAgent.agentNameChoose':'Nombre del agente',
  'adsAgent.adsName': 'Nombre de configuración de atribución',
  'adsAgent.agentName': 'Nombre del agente',
  'adsAgent.adsType': 'Canal de atribución',
  'adsAgent.operator': 'Operador',
  'adsAgent.operationTime': 'Tiempo de operación',
  'adsAgent.action': 'Acción',

  // Form labels
  'adsAgent.adsAccount': 'Configuración de atribución',

  // Form validation
  'adsAgent.agentNameRequired': 'Por favor seleccione el agente',
  'adsAgent.adsTypeRequired': 'Por favor seleccione el canal de atribución',
  'adsAgent.adsAccountRequired': 'Por favor seleccione la configuración de atribución',

  // Messages
  'adsAgent.addSuccess': 'Añadido exitosamente',
  'adsAgent.addFailed': 'Error al añadir',
  'adsAgent.deleteSuccess': 'Eliminado exitosamente',
  'adsAgent.deleteFailed': 'Error al eliminar',
  'adsAgent.confirmDelete': '¿Seguro que desea eliminar este registro?',
  'adsAgent.fetchTypesFailed': 'Error al obtener tipos de plataforma de atribución',
  'adsAgent.fetchAdsAccountsFailed': 'Error al obtener configuraciones de atribución',
  'adsAgent.fetchAgentsFailed': 'Error al obtener lista de agentes',

  // Pagination
  'adsAgent.totalRecords': 'Total {total} registros',
  'adsAgent.pagination': 'Página {current} de {page}, Total {total} registros',
};
